var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckCircleIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.72209 19.899C8.28435 20.9428 10.1211 21.5 12 21.5C14.5187 21.4972 16.9335 20.4954 18.7144 18.7144C20.4954 16.9335 21.4972 14.5187 21.5 12C21.5 10.1211 20.9428 8.28435 19.899 6.72209C18.8551 5.15982 17.3714 3.94218 15.6355 3.22315C13.8996 2.50412 11.9895 2.31598 10.1466 2.68254C8.30383 3.0491 6.61109 3.95389 5.28249 5.28249C3.95389 6.61109 3.0491 8.30383 2.68254 10.1466C2.31598 11.9895 2.50412 13.8996 3.22315 15.6355C3.94218 17.3714 5.15982 18.8551 6.72209 19.899ZM6.78071 5.29472C8.27228 4.13234 10.109 3.50076 12 3.5C13.4096 3.5006 14.7969 3.85134 16.0374 4.52072C17.2779 5.1901 18.3327 6.15716 19.107 7.335C20.1445 8.916 20.6249 10.7979 20.4722 12.6828C20.3194 14.5676 19.5423 16.3476 18.2638 17.7409C16.9853 19.1343 15.2785 20.0613 13.4137 20.3751C11.549 20.689 9.63276 20.3718 7.96858 19.4738C6.3044 18.5758 4.98735 17.1483 4.226 15.4174C3.46464 13.6864 3.30249 11.7509 3.76523 9.91738C4.22797 8.08386 5.28914 6.45711 6.78071 5.29472ZM7.147 12.355L10.5 15.7085L16.604 9.60699L15.897 8.89999L10.5 14.2945L7.854 11.65L7.147 12.355Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckCircleIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Check_Circle_Icon.f33c0edb7373455a1362d34a822de3d3.svg";